// Lot 6 — « Depuis le dernier rendez-vous » : les faits, rien d'autre.
// Quatre tendances (énergie, fatigue, digestion, faim) telles que la cliente
// les a notées, ses mots, les repas prévus / remplacés / sautés, les notes
// d'Anissa du rendez-vous, le poids seulement si son suivi est activé.

import { formaterDate } from './suiviEcran';
import { motsDeLaCliente, poidsDepuis, quatreTendances, repasDepuis } from './services/suiviRessenti';

const dateJour = (jour) => formaterDate(`${jour}T12:00:00Z`);
const kg = (n) => `${String(n).replace('.', ',')} kg`;

export default function DepuisDernierRdv({ client, rdv = null, donnees = null }) {
  const titre = rdv?.date
    ? `Depuis le dernier rendez-vous (${formaterDate(rdv.date)})`
    : 'Les 30 derniers jours (aucun rendez-vous relu)';

  return (
    <section className="jrn-block suivi-ressenti">
      <div className="jrn-block__head">
        <h3 className="jrn-block__title">{titre}</h3>
      </div>

      {(rdv?.resume || rdv?.note) && (
        <div className="suivi-ressenti__notes">
          <h4 className="jrn-label">Tes notes du rendez-vous</h4>
          {rdv.resume && <p>{rdv.resume}</p>}
          {rdv.note && <p>{rdv.note}</p>}
        </div>
      )}

      {!donnees && <p className="jrn-block__intro">Chargement des données de l’app…</p>}
      {donnees && !donnees.ok && <p className="jrn-block__intro" role="status">{donnees.message}</p>}
      {donnees?.ok && donnees.trouvee === false && (
        <p className="jrn-block__intro" role="status">Cette cliente n’a pas encore utilisé l’app.</p>
      )}
      {donnees?.ok && donnees.coupee && (
        <p className="jrn-block__intro" role="status">
          L’app ne donne les données que depuis le {formaterDate(donnees.debutCharge + 'T12:00:00Z')} : la période est coupée.
        </p>
      )}
      {donnees?.ok && donnees.trouvee !== false && <Contenu client={client} donnees={donnees} />}
    </section>
  );
}

function Contenu({ client, donnees }) {
  const tendances = quatreTendances(donnees.feedbacks);
  const mots = motsDeLaCliente(donnees.feedbacks);
  const { totaux, remplaces, sautes } = repasDepuis(donnees.jours);
  const poids = poidsDepuis(client, donnees.feedbacks);

  return (
    <>
      <h4 className="jrn-label">Ressentis</h4>
      {donnees.feedbacks.length === 0 ? (
        <p className="jrn-block__intro">Aucun ressenti noté dans l’app sur cette période.</p>
      ) : (
        <ul className="suivi-ressenti__tendances">
          {tendances.map((t) => <li key={t.axis}>{t.summary}</li>)}
        </ul>
      )}

      {mots.length > 0 && (
        <>
          <h4 className="jrn-label">Ses mots</h4>
          <ul className="suivi-ressenti__mots">
            {mots.slice(0, 10).map((m) => (
              <li key={`${m.date}-${m.texte.slice(0, 20)}`}>{dateJour(m.date)} : « {m.texte} »</li>
            ))}
          </ul>
        </>
      )}

      <h4 className="jrn-label">Repas</h4>
      {totaux.renseignes === 0 ? (
        <p className="jrn-block__intro">Aucun repas renseigné dans l’app sur cette période.</p>
      ) : (
        <>
          <p>
            {totaux.commePrevu} comme prévu · {totaux.remplaces} remplacé{totaux.remplaces > 1 ? 's' : ''} · {totaux.sautes} sauté{totaux.sautes > 1 ? 's' : ''}
            {totaux.prevus ? ` (${totaux.renseignes} renseignés sur ${totaux.prevus} prévus)` : ` (${totaux.renseignes} renseignés)`}
          </p>
          {remplaces.length > 0 && (
            <ul className="suivi-ressenti__remplaces">
              {remplaces.slice(0, 15).map((r) => (
                <li key={`${r.jour}-${r.repas}-${r.prevu}`}>
                  {dateJour(r.jour)} · {r.repas}{r.prevu ? ` « ${r.prevu} »` : ''} remplacé par {r.remplacePar ? `« ${r.remplacePar} »` : 'un autre repas'}
                </li>
              ))}
            </ul>
          )}
          {sautes.length > 0 && (
            <ul className="suivi-ressenti__sautes">
              {sautes.slice(0, 15).map((r) => (
                <li key={`${r.jour}-${r.repas}`}>{dateJour(r.jour)} · {r.repas}{r.prevu ? ` « ${r.prevu} »` : ''} sauté</li>
              ))}
            </ul>
          )}
        </>
      )}

      {poids && (
        <>
          <h4 className="jrn-label">Poids</h4>
          {poids.mesures.length === 0 ? (
            <p className="jrn-block__intro">Aucune mesure sur cette période.</p>
          ) : (
            <p>
              {poids.mesures.length} mesure{poids.mesures.length > 1 ? 's' : ''} : {kg(poids.premiere.kg)} le {dateJour(poids.premiere.date)}
              {poids.mesures.length > 1 ? `, ${kg(poids.derniere.kg)} le ${dateJour(poids.derniere.date)}` : ''}.
            </p>
          )}
        </>
      )}
    </>
  );
}
